// const video0 = import('./assets/MP4/NO28/NO28_NFT004M.mp4')
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from 'react-router-dom';
import { Helmet } from "react-helmet";
import { connect } from "./redux/blockchain/blockchainActions";
import { fetchData } from "./redux/data/dataActions";
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import * as s from "./styles/globalStyles";

import favicon from './favicon.png'
import img0 from './assets/IMG/1.jpg'
import img1 from './assets/IMG/4.jpg'
import img2 from './assets/IMG/3.jpg'
import img3 from './assets/IMG/2.jpg'
import img6 from './assets/IMG/48.jpg'
import img5 from './assets/IMG/49.jpg'
import img4 from './assets/IMG/50.jpg'
import img7 from './assets/IMG/29.jpg'
import img8 from './assets/IMG/30.jpg'
import img9 from './assets/IMG/31.jpg'
import img10 from './assets/IMG/32.jpg'
import img11 from './assets/IMG/33.jpg'
import img12 from './assets/IMG/34.jpg'
import img13 from './assets/IMG/35.jpg'
import img14 from './assets/IMG/36.jpg'
import img15 from './assets/IMG/37.jpg'
import img16 from './assets/IMG/38.jpg'
import img17 from './assets/IMG/39.jpg'
import img18 from './assets/IMG/40.jpg'
import img19 from './assets/IMG/41.jpg'
import img20 from './assets/IMG/42.jpg'
import img21 from './assets/IMG/43.jpg'
import img22 from './assets/IMG/44.jpg'
import img23 from './assets/IMG/45.jpg'
import img24 from './assets/IMG/46.jpg'
import img25 from './assets/IMG/47.jpg'
import video0 from './assets/MP4/NO28/NO28_NFT004M.mp4'
import video1 from './assets/MP4/NO28/NO28_NFT003M.mp4'
import video2 from './assets/MP4/NO28/NO28_NFT001M.mp4'
import video3 from './assets/MP4/NO28/NO28_NFT002M.mp4'
import videoGlassCream from './assets/MP4/Glass/N0164_SUNGLASSESxPM_CREAMM.mp4'
import videoGlassRed from './assets/MP4/Glass/N0164_SUNGLASSESxPM_REDM.mp4'
import videoGlassBlack from './assets/MP4/Glass/NO164_SUNGLASSESxPM_BLACKM.mp4'
import videoArt1 from './assets/MP4/ART/AdamSpizak/AdamSpizak4ETHM.mp4'
import videoArt2 from './assets/MP4/ART/EliaBertolotti/EliaBertolotti_0.5ETHM.mp4'
import videoArt3 from './assets/MP4/ART/JamesAbadi/JAMESABADI-Clarity_Slime-0.5ETHM.mp4'
import videoArt4 from './assets/MP4/ART/JamesSmith/A$AP_ANT_A$AP_Rocky_The_God_HourM.mp4'
import videoArt5 from './assets/MP4/ART/JamesSmith/Brockhampton_Sugar_1M.mp4'
import videoArt6 from './assets/MP4/ART/JamesSmith/Frank_Ocean_Blonde_NewM.mp4'
import videoArt7 from './assets/MP4/ART/JamesSmith/iPod_Exploded-0.25ETHM.mp4'
import videoArt8 from './assets/MP4/ART/JamesSmith/Mac_Miler_Faces-0.25ETHM.mp4'
import videoArt9 from './assets/MP4/ART/JamesSmith/Playboi_Carti_Narcissist-0.25ETHM.mp4'
import videoArt10 from './assets/MP4/ART/JamesSmith/PS1_Exploded-0.25ETHM.mp4'
import videoArt11 from './assets/MP4/ART/JonSanchez/JonSanchez-1ETHM.mp4'
import videoArt12 from './assets/MP4/ART/JonSanchez/NO.28NFT-0.11ETHM.mp4'
import videoArt13 from './assets/MP4/ART/KaoruTanaka/KaoruTanaka-1.2ETHM.mp4'
import videoArt14 from './assets/MP4/ART/AbdoulayeBarry/AbdoulayeBarryM.mp4'
import videoArt15 from './assets/MP4/ART/TiagoMarinho/TiagoMarinho-1ETHM.mp4'
import videoArt16 from './assets/MP4/ART/TimoHelgert/TimoHelgert-1ETHM.mp4'
import videoArt17 from './assets/MP4/ART/WallenDiaz/WallenDiaz1-1ETHM.mp4'
import videoArt18 from './assets/MP4/ART/WallenDiaz/WallenDiaz2-1ETHM.mp4'
import videoArt19 from './assets/MP4/ART/WallenDiaz/WallenDiaz3-1ETHM.mp4'

function App() {
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const [select, setSelect] = useState("video");
  const [glitchInited, setGlicthInited] = useState(false)
  const [animateMenu, setAnimateMenu] = useState(false)
  const [animateLogo, setAnimateLogo] = useState(false)
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("Press MINT to send transaction to ETH BlockChain");
  const [activeNFT, setActiveNFT] = useState(null);
  const sUsrAg = navigator.userAgent;
  const isChrome = sUsrAg.indexOf("Chrome") > -1;
  const [searchParams] = useSearchParams();

  let i = 0
  const canvasTag = document.querySelector("canvas")
  // const images = []
  const images = [img0, img1, img2, img3, img4, img5, img6, img7, img8, img9, img10
  , img11, img12, img13, img14, img15, img16, img17, img18, img19, img20
  , img21, img22, img23, img24, img25].map(src => {
    const image = document.createElement("img")
    image.src = src
    image.style.width = '100px'
    image.style.height = 'auto'
    return image
  })

  const initGlitch = () => {
    setGlicthInited(true)
    console.log(activeNFT)
    canvasTag.width = window.innerWidth * 2
    canvasTag.height = window.innerHeight * 2

    canvasTag.style.width = window.innerWidth + "px"
    canvasTag.style.height = window.innerHeight + "px"

    const context = canvasTag.getContext("2d")
    context.scale(2, 2)

    let aimX = null
    let aimY = null
    let currentX = null
    let currentY = null

    document.addEventListener("mousemove", function (event) {
      console.log('dfsdf')
      aimX = event.pageX
      aimY = event.pageY
      if (currentX === null) {
        currentX = event.pageX
        currentY = event.pageY
      }
    })

    document.addEventListener("touchmove", function (event) {
      aimX = event.pageX
      aimY = event.pageY
      if (currentX === null) {
        currentX = event.pageX
        currentY = event.pageY
      }
    })

    canvasTag.addEventListener("click", function () {
      i = i + 1
      if (i >= images.length) {
        i = 0
      }
    })

    const draw = function () {
      if (currentX) {
        if (images[i].complete) {
          context.drawImage(images[i], currentX - 100, currentY - 150, 200, 300)
        }

        currentX = currentX + (aimX - currentX) * 0.1
        currentY = currentY + (aimY - currentY) * 0.1
      }

      requestAnimationFrame(draw)
    }

    draw()
  }

  const handleSelectChange = event => {
    const value = event.target.value;
    setSelect(value);
  };

  const clearCanvas = () => {
    canvasTag.getContext('2d').clearRect(0, 0, canvasTag.width, canvasTag.height);
  }

  useEffect(() => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account));
    }
  }, [blockchain.smartContract, dispatch]);

  useEffect(() => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`)

    setTimeout(() => setAnimateLogo(true), 1500)
  })

  useEffect(() => {
    setTimeout(() => setAnimateMenu(true), 3500)
  }, [animateLogo])

  useEffect(() => {
    if (select === 'video' && activeNFT !== null) {
      clearCanvas()
    } else if (select === 'glitch' && glitchInited === false) {
      initGlitch()
    }
  }, [select])

  const startMint1 = () => {
    setLoading(true);
    blockchain.smartContract.methods
    .mintN28(blockchain.account, 1)
    .send({from: blockchain.account, value: 23000000000000000000})
    .once("error", (err) => {
      console.log(err);
      setLoading(false);
      setStatus("Error");
    }).then((receipt) => {
      console.log(receipt);
      setLoading(false);
      setStatus("Congrat u now own a NO28 NFT !");
    });
  };

  const startMint2 = () => {
    setLoading(true);
    blockchain.smartContract.methods
    .mintN28(blockchain.account, 2)
    .send({from: blockchain.account, value: 450000000000000000})
    .once("error", (err) => {
      console.log(err);
      setLoading(false);
      setStatus("Error");
    }).then((receipt) => {
      console.log(receipt);
      setLoading(false);
      setStatus("Congrat u now own a NO28 NFT !");
    });
  };

  const startMint3 = () => {
    setLoading(true);
    blockchain.smartContract.methods
    .mintN28(blockchain.account, 3)
    .send({from: blockchain.account, value: 250000000000000000})
    .once("error", (err) => {
      console.log(err);
      setLoading(false);
      setStatus("Error");
    }).then((receipt) => {
      console.log(receipt);
      setLoading(false);
      setStatus("Congrat u now own a NO28 NFT !");
    });
  };

  const startMint4 = () => {
    setLoading(true);
    blockchain.smartContract.methods
    .mintCard(blockchain.account, 1)
    .send({from: blockchain.account, value: 120000000000000000})
    .once("error", (err) => {
      console.log(err);
      setLoading(false);
      setStatus("Error");
    }).then((receipt) => {
      console.log(receipt);
      setLoading(false);
      setStatus("Congrat u now own a NO28 NFT !");
    });
  };

  const startMint5 = (activeNFT, price) => {
    setLoading(true);
    blockchain.smartContract.methods
    .mintArt(blockchain.account, activeNFT)
    .send({from: blockchain.account, value: price})
    .once("error", (err) => {
      console.log(err);
      setLoading(false);
      setStatus("Error");
    }).then((receipt) => {
      console.log(receipt);
      setLoading(false);
      setStatus("Transaction accepted check ur wallet");
    });
  };

  const startMintBlackGlass = () => {
    setLoading(true);
    blockchain.smartContract.methods
    .mintBlackGlasse(blockchain.account)
    .send({from: blockchain.account, value: 70000000000000000})
    .once("error", (err) => {
      console.log(err);
      setLoading(false);
      setStatus("Error");
    }).then((receipt) => {
      console.log(receipt);
      setLoading(false);
      setStatus("Congrat u have a new SUNGLASSE!");
    });
  };
  const startMintRedGlass = () => {
    setLoading(true);
    blockchain.smartContract.methods
    .mintRedGlasse(blockchain.account)
    .send({from: blockchain.account, value: 70000000000000000})
    .once("error", (err) => {
      console.log(err);
      setLoading(false);
      setStatus("Error");
    }).then((receipt) => {
      console.log(receipt);
      setLoading(false);
      setStatus("Congrat u have a new SUNGLASSE!");
    });
  };
  const startMintCreamGlass = () => {
    setLoading(true);
    blockchain.smartContract.methods
    .mintCreamGlasse(blockchain.account)
    .send({from: blockchain.account, value: 70000000000000000})
    .once("error", (err) => {
      console.log(err);
      setLoading(false);
      setStatus("Error");
    }).then((receipt) => {
      console.log(receipt);
      setLoading(false);
      setStatus("Congrat u have a new SUNGLASSE!");
    });
  };

  return (
    <s.Screen>
      <Helmet>
        <meta charSet="utf-8" />
        <title>NO28 | NFTs</title>
        <link rel="canonical" href="https://no28.world/" />
        <link rel="icon" type="image/png" href={favicon} />
      </Helmet>
      <s.Container onClick={(e) => {
         if (e.target.tagName !== 'A' && e.target.tagName !== 'LABEL' && e.target.tagName !== 'INPUT' && e.target.tagName !== 'H3') {
           e.preventDefault();
            const id = parseInt(searchParams.get('id'));
            if (activeNFT === null && select === "glitch") {
              initGlitch()
              setActiveNFT(0)
            } else if (activeNFT === null && select === "video") {
              id ? setActiveNFT(id) : setActiveNFT(0)
            } else if (activeNFT === 25) {
              setActiveNFT(0)
            } else {
              setActiveNFT(activeNFT + 1)
            }
         }
       }}
      >
        <s.Menu animate={animateMenu}>
          <s.MenuIntro>WELCOME TO ® NO 28 DIMENSION,
          A DIGITAL WORLD WHERE YOU CAN MINT NFTs THAT REPRESENT THE FOUNDATION OF ® NO 28.
          ALSO FIND WORLDWIDE ARTISTS’ ARTWORKS SHOWED AT THE "HOLOGRAPHIC DIMENSIONS" ART SHOW.
            <s.MenuIntroLinkWrap>
              <s.MenuIntroLink href='https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn'>(INSTALL METAMASK EXTENSION)</s.MenuIntroLink>
              { isChrome === false && <s.MenuIntroItem>PURCHASES ONLY AVAILABLE VIA GOOGLE CHROME</s.MenuIntroItem> }
              <s.MenuIntroLink href='https://no28.world/'>(BACK TO NO28.WORLD)</s.MenuIntroLink>
            </s.MenuIntroLinkWrap>
          </s.MenuIntro>
          <s.MenuNav>
            <s.MenuNavItem onClick={clearCanvas}>(clear)</s.MenuNavItem>
            <s.Item>
              <s.MenuNavRadio
                  type="radio"
                  name="radio"
                  value="glitch"
                  id="glitch"
                  checked={select === "glitch"}
                  onChange={event => handleSelectChange(event)}
              />
              <s.MenuNavRadioLabel
                  htmlFor="glitch"
              >(glitch)</s.MenuNavRadioLabel>
            </s.Item>
            <s.Item>
              <s.MenuNavRadio
                  type="radio"
                  name="radio"
                  value="video"
                  id='video'
                  checked={select === "video"}
                  onChange={event => handleSelectChange(event)}
              />
              <s.MenuNavRadioLabel
                  htmlFor="video"
              >(video)</s.MenuNavRadioLabel>
            </s.Item>
          </s.MenuNav>
        </s.Menu>
        <s.LogoWrapper animate={animateLogo}>
          <svg className='logo-main' viewBox="0 0 1452 179" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1391.09 151.48C1377.38 151.48 1367.93 144.15 1367.93 126.66C1367.93 112.24 1376.67 101.84 1390.86 101.84C1403.86 101.84 1413.78 110.59 1413.78 126.19C1413.78 145.33 1404.09 151.48 1391.09 151.48V151.48ZM1391.09 70.88C1377.86 70.88 1371.71 61.19 1371.71 49.13C1371.71 35.18 1379.98 28.33 1391.33 28.33C1402.44 28.33 1411.42 34.47 1411.42 49.13C1411.42 63.08 1403.62 70.88 1391.09 70.88V70.88ZM1421.35 85.53C1437.42 81.98 1448.77 68.27 1449 47.24C1449.24 18.17 1425.13 0.910004 1391.57 0.910004C1351.57 0.910004 1333.89 22.66 1333.42 48.42C1333.1 56.6921 1335.52 64.8381 1340.31 71.5922C1345.1 78.3463 1351.98 83.3303 1359.89 85.77C1336.26 94.99 1329.89 112.01 1329.64 128.55C1329.16 160.7 1353.27 178.19 1389.91 178.66C1425.84 179.14 1451.37 161.41 1451.84 128.55C1452.08 110.12 1444.75 94.75 1421.35 85.55V85.53ZM1202.7 57.4H1241.94C1241.23 45.11 1245.02 32.11 1261.56 32.11C1274.56 32.11 1280.94 41.33 1280.47 53.39C1280.24 60.95 1276.22 68.99 1267.47 79.15C1258.25 89.78 1244.07 104.68 1235.32 112.24L1203.89 140.13V174.88H1320.89V140.13C1314.98 141.32 1310.49 141.55 1286.14 142.26C1270.07 142.73 1263.22 142.5 1244.54 142.5C1313.54 92.62 1320.42 70.17 1320.89 51.73C1321.6 22.89 1302.69 0.910004 1263.22 0.910004C1240.05 0.910004 1202.22 7.05999 1202.7 57.4V57.4ZM1067.5 28.57C1082.63 28.57 1096.11 39.2 1096.11 88.37C1096.11 131.86 1087.11 150.06 1067.74 150.06C1047.65 150.06 1038.43 131.86 1038.43 88.37C1038.43 38.73 1052.14 28.57 1067.5 28.57ZM1067.5 0.910004C1019.76 0.910004 998.72 31.91 998.5 88.84C998.27 156.92 1025.92 178.66 1067.29 178.66C1109.6 178.66 1136.07 156.21 1135.84 88.84C1135.6 32.35 1115.98 0.910004 1067.52 0.910004H1067.5ZM356.24 127.84L356.71 137.3L306.84 4.69H249.4V174.88H286.74L285.56 45.11L285.09 36.11L336.86 174.86H391.7V4.69H354.82L356.24 127.84ZM103.56 114.37C103.56 124.3 104.74 137.06 106.87 139.19H129.56C127.2 135.88 126.02 123.82 125.56 114.37C124.85 102.08 121.56 90.97 106.18 89.55C118.71 86.71 126.27 79.15 126.27 64.73C126.27 47.24 112.09 38.96 95.54 38.96H54.87V139.19H76.14V99.19H87.49C97.65 99.19 103.56 104.19 103.56 114.32V114.37ZM89.61 54.52C98.83 54.52 104.51 59.72 104.51 68.7C104.51 78.39 98.36 83.12 88.91 83.12H76.14V54.52H89.61ZM89.38 14.81C130.51 14.81 163.6 45.54 163.6 89.5C163.6 132.75 130.98 164.67 89.38 164.67C48.25 164.67 15.63 133.47 15.63 89.5C15.63 45.06 48.72 14.81 89.38 14.81ZM89.61 0.859985C40.68 0.859985 0.27002 36.79 0.27002 89.73C0.27002 141.73 39.74 178.61 89.61 178.61C139.96 178.61 178.96 141.27 178.96 89.73C178.96 36.79 139.02 0.859985 89.61 0.859985" fill="#ffffff"/>
          </svg>
        </s.LogoWrapper>
        <s.TextDescription animate={animateMenu}>(CLICK ANYWHERE TO SEE NFTS)</s.TextDescription>
        <s.StyledButtonWrapper>
          { activeNFT === 0 ? (
              <s.StyledButton
                  onClick={(e) => {
                    e.preventDefault();

                    if (blockchain.account === "" || blockchain.smartContract === null) {
                      dispatch(connect());
                      console.log(blockchain.smartContract);
                    } else {
                      startMint1();
                    }
                  }}
              >
                <s.StyledButtonTitle>MINT DIMENSION by no28</s.StyledButtonTitle>
                <div>23 ETH</div>
                <div>{status}</div>
              </s.StyledButton>
          ) : activeNFT === 1 ? (
              <s.StyledButton
                  onClick={(e) => {
                    e.preventDefault();

                    console.log(blockchain)
                    if (blockchain.account === "" || blockchain.smartContract === null) {
                      dispatch(connect());
                    } else {
                      startMint4();
                    }
                  }}
              >
                <s.StyledButtonTitle>MINT MEMBER CARD by no28</s.StyledButtonTitle>
                <div>0.12 ETH</div>
                <div>{status}</div>
              </s.StyledButton>
          ) : activeNFT === 2 ? (
              <s.StyledButton
                  onClick={(e) => {
                    e.preventDefault();

                    if (blockchain.account === "" || blockchain.smartContract === null) {
                      dispatch(connect());
                    } else {
                      startMint3();
                    }
                  }}
              >
                <s.StyledButtonTitle>MINT NO163 SKYMASK by no28</s.StyledButtonTitle>
                <div>0.25 ETH</div>
                <div>{status}</div>
              </s.StyledButton>
          ) : activeNFT === 3 ? (
              <s.StyledButton
                  onClick={(e) => {
                    e.preventDefault();
                    if (blockchain.account === "" || blockchain.smartContract === null) {
                      dispatch(connect());
                    } else {
                      startMint2();
                    }
                  }}
              >
                <s.StyledButtonTitle>MINT CYBER RACE BIKE by no28</s.StyledButtonTitle>
                <div>0.45 ETH</div>
                <div>{status}</div>
              </s.StyledButton>
          ) : activeNFT === 4 ? (
            <s.StyledButton
                onClick={(e) => {
                  e.preventDefault();

                  if (blockchain.account === "" || blockchain.smartContract === null) {
                    dispatch(connect());
                  } else {
                    startMintBlackGlass();
                  }
                }}
            >
              <s.StyledButtonTitle>MINT NO164 SUNGLASSES x PM BLACK</s.StyledButtonTitle>
              <div>0.07 ETH</div>
              <div>{status}</div>
            </s.StyledButton>
          ) : activeNFT === 5 ? (
            <s.StyledButton
                onClick={(e) => {
                  e.preventDefault();

                  if (blockchain.account === "" || blockchain.smartContract === null) {
                    dispatch(connect());
                  } else {
                    startMintRedGlass();
                  }
                }}
            >
              <s.StyledButtonTitle>MINT NO164 SUNGLASSES x PM RED</s.StyledButtonTitle>
              <div>0.07 ETH</div>
              <div>{status}</div>
            </s.StyledButton>
          ) : activeNFT === 6 ? (
            <s.StyledButton
                onClick={(e) => {
                  e.preventDefault();

                  if (blockchain.account === "" || blockchain.smartContract === null) {
                    dispatch(connect());
                  } else {
                    startMintCreamGlass();
                  }
                }}
            >
              <s.StyledButtonTitle>MINT NO164 SUNGLASSES x PM CREAM</s.StyledButtonTitle>
              <div>0.07 ETH</div>
              <div>{status}</div>
            </s.StyledButton>
          ) : activeNFT === 7 ? (
            <s.StyledButton
                onClick={(e) => {
                  e.preventDefault();

                  if (blockchain.account === "" || blockchain.smartContract === null) {
                    dispatch(connect());
                  } else {
                    startMint5(activeNFT + 22, 4000000000000000000);
                  }
                }}
            >
              <s.StyledButtonTitle>MINT Adam Spizak NFT</s.StyledButtonTitle>
              <div>4 ETH</div>
              <div>{status}</div>
            </s.StyledButton>
          ) : activeNFT === 8 ? (
            <s.StyledButton
                onClick={(e) => {
                  e.preventDefault();

                  if (blockchain.account === "" || blockchain.smartContract === null) {
                    dispatch(connect());
                  } else {
                    startMint5(activeNFT + 22, 500000000000000000);
                  }
                }}
            >
              <s.StyledButtonTitle>MINT Elia Bertolotti NFT</s.StyledButtonTitle>
              <div>0.5 ETH</div>
              <div>{status}</div>
            </s.StyledButton>
          ) : activeNFT === 9 ? (
            <s.StyledButton
                onClick={(e) => {
                  e.preventDefault();

                  if (blockchain.account === "" || blockchain.smartContract === null) {
                    dispatch(connect());
                  } else {
                    startMint5(activeNFT + 22, 500000000000000000);
                  }
                }}
            >
              <s.StyledButtonTitle>MINT Clarity Slime by James Abadi</s.StyledButtonTitle>
              <div>0.5 ETH</div>
              <div>{status}</div>
            </s.StyledButton>
          ) : activeNFT === 10 ? (
            <s.StyledButton
                onClick={(e) => {
                  e.preventDefault();

                  if (blockchain.account === "" || blockchain.smartContract === null) {
                    dispatch(connect());
                  } else {
                    startMint5(activeNFT + 22, 250000000000000000);
                  }
                }}
            >
              <s.StyledButtonTitle>MINT A$AP ANT A$AP Rocky The God Hour by James Smith</s.StyledButtonTitle>
              <div>0.25 ETH</div>
              <div>{status}</div>
            </s.StyledButton>
          ) : activeNFT === 11 ? (
            <s.StyledButton
                onClick={(e) => {
                  e.preventDefault();

                  if (blockchain.account === "" || blockchain.smartContract === null) {
                    dispatch(connect());
                  } else {
                    startMint5(activeNFT + 22, 250000000000000000);
                  }
                }}
            >
              <s.StyledButtonTitle>MINT Brockhampton Sugar 1 by James Smith</s.StyledButtonTitle>
              <div>0.25 ETH</div>
              <div>{status}</div>
            </s.StyledButton>
          ) : activeNFT === 12 ? (
            <s.StyledButton
                onClick={(e) => {
                  e.preventDefault();

                  if (blockchain.account === "" || blockchain.smartContract === null) {
                    dispatch(connect());
                  } else {
                    startMint5(activeNFT + 22, 250000000000000000);
                  }
                }}
            >
              <s.StyledButtonTitle>MINT Frank Ocean Blonde New by James Smith</s.StyledButtonTitle>
              <div>0.25 ETH</div>
              <div>{status}</div>
            </s.StyledButton>
          ) : activeNFT === 13 ? (
            <s.StyledButton
                onClick={(e) => {
                  e.preventDefault();

                  if (blockchain.account === "" || blockchain.smartContract === null) {
                    dispatch(connect());
                  } else {
                    startMint5(activeNFT + 22, 250000000000000000);
                  }
                }}
            >
              <s.StyledButtonTitle>MINT iPod Exploded by James Smith</s.StyledButtonTitle>
              <div>0.25 ETH</div>
              <div>{status}</div>
            </s.StyledButton>
          ) : activeNFT === 14 ? (
            <s.StyledButton
                onClick={(e) => {
                  e.preventDefault();

                  if (blockchain.account === "" || blockchain.smartContract === null) {
                    dispatch(connect());
                  } else {
                    startMint5(activeNFT + 22, 250000000000000000);
                  }
                }}
            >
              <s.StyledButtonTitle>MINT Mac Miler Faces by James Smith</s.StyledButtonTitle>
              <div>0.25 ETH</div>
              <div>{status}</div>
            </s.StyledButton>
          ) : activeNFT === 15 ? (
            <s.StyledButton
                onClick={(e) => {
                  e.preventDefault();

                  if (blockchain.account === "" || blockchain.smartContract === null) {
                    dispatch(connect());
                  } else {
                    startMint5(activeNFT + 22, 250000000000000000);
                  }
                }}
            >
              <s.StyledButtonTitle>MINT Playboi Carti Narcissist by James Smith</s.StyledButtonTitle>
              <div>0.25 ETH</div>
              <div>{status}</div>
            </s.StyledButton>
          ) : activeNFT === 16 ? (
            <s.StyledButton
                onClick={(e) => {
                  e.preventDefault();
                  if (blockchain.account === "" || blockchain.smartContract === null) {
                    dispatch(connect());
                  } else {
                    startMint5(activeNFT + 22, 250000000000000000);
                  }
                }}
            >
              <s.StyledButtonTitle>MINT PS1 Exploded by James Smith</s.StyledButtonTitle>
              <div>0.25 ETH</div>
              <div>{status}</div>
            </s.StyledButton>
          ) : activeNFT === 17 ? (
            <s.StyledButton
                onClick={(e) => {
                  e.preventDefault();
                  if (blockchain.account === "" || blockchain.smartContract === null) {
                    dispatch(connect());
                  } else {
                    startMint5(activeNFT + 22, 1000000000000000000);
                  }
                }}
            >
              <s.StyledButtonTitle>MINT Jon Sanchez nft</s.StyledButtonTitle>
              <div>1 ETH</div>
              <div>{status}</div>
            </s.StyledButton>
          ) : activeNFT === 18 ? (
            <s.StyledButton
                onClick={(e) => {
                  e.preventDefault();
                  if (blockchain.account === "" || blockchain.smartContract === null) {
                    dispatch(connect());
                  } else {
                    startMint5(activeNFT + 22, 110000000000000000);
                  }
                }}
            >
              <s.StyledButtonTitle>MINT NO.28 NFT by Jon Sanchez</s.StyledButtonTitle>
              <div>0.11 ETH</div>
              <div>{status}</div>
            </s.StyledButton>
          ) : activeNFT === 19 ? (
            <s.StyledButton
                onClick={(e) => {
                  e.preventDefault();
                  if (blockchain.account === "" || blockchain.smartContract === null) {
                    dispatch(connect());
                  } else {
                    startMint5(activeNFT + 22, 1200000000000000000);
                  }
                }}
            >
              <s.StyledButtonTitle>MINT Kaoru Tanaka NFT</s.StyledButtonTitle>
              <div>1.2 ETH</div>
              <div>{status}</div>
            </s.StyledButton>
          ) : activeNFT === 20 ? (
            <s.StyledButton
                onClick={(e) => {
                  e.preventDefault();
                  if (blockchain.account === "" || blockchain.smartContract === null) {
                    dispatch(connect());
                  } else {
                    startMint5(activeNFT + 22, 490000000000000000);
                  }
                }}
            >
              <s.StyledButtonTitle>MINT Abdoulaye Barry NFT</s.StyledButtonTitle>
              <div>0.49 ETH</div>
              <div>{status}</div>
            </s.StyledButton>
          ) : activeNFT === 21 ? (
            <s.StyledButton
                onClick={(e) => {
                  e.preventDefault();
                  if (blockchain.account === "" || blockchain.smartContract === null) {
                    dispatch(connect());
                  } else {
                    startMint5(activeNFT + 22, 1000000000000000000);
                  }
                }}
            >
              <s.StyledButtonTitle>MINT Tiago Marinho NFT</s.StyledButtonTitle>
              <div>1 ETH</div>
              <div>{status}</div>
            </s.StyledButton>
          ) : activeNFT === 22 ? (
            <s.StyledButton
                onClick={(e) => {
                  e.preventDefault();
                  if (blockchain.account === "" || blockchain.smartContract === null) {
                    dispatch(connect());
                  } else {
                    startMint5(activeNFT + 22, 1000000000000000000);
                  }
                }}
            >
              <s.StyledButtonTitle>MINT Timo Helgert NFT</s.StyledButtonTitle>
              <div>1 ETH</div>
              <div>{status}</div>
            </s.StyledButton>
          ) : activeNFT === 23 ? (
            <s.StyledButton
                onClick={(e) => {
                  e.preventDefault();
                  if (blockchain.account === "" || blockchain.smartContract === null) {
                    dispatch(connect());
                  } else {
                    startMint5(activeNFT + 22, 1000000000000000000);
                  }
                }}
            >
              <s.StyledButtonTitle>MINT Wallen Diaz NFT 1</s.StyledButtonTitle>
              <div>1 ETH</div>
              <div>{status}</div>
            </s.StyledButton>
          ) : activeNFT === 24 ? (
            <s.StyledButton
                onClick={(e) => {
                  e.preventDefault();
                  if (blockchain.account === "" || blockchain.smartContract === null) {
                    dispatch(connect());
                  } else {
                    startMint5(activeNFT + 22, 1000000000000000000);
                  }
                }}
            >
              <s.StyledButtonTitle>MINT Wallen Diaz NFT 2</s.StyledButtonTitle>
              <div>1 ETH</div>
              <div>{status}</div>
            </s.StyledButton>
          ) : activeNFT === 25 ? (
            <s.StyledButton
                onClick={(e) => {
                  e.preventDefault();
                  if (blockchain.account === "" || blockchain.smartContract === null) {
                    dispatch(connect());
                  } else {
                    startMint5(activeNFT + 22, 1000000000000000000);
                  }
                }}
            >
              <s.StyledButtonTitle>MINT Wallen Diaz NFT 3</s.StyledButtonTitle>
              <div>1 ETH</div>
              <div>{status}</div>
            </s.StyledButton>
          ) : null }
          {loading ? (
              <>
                <s.TextDescription>
                  loading...
                </s.TextDescription>
              </>
          ) : null }
        </s.StyledButtonWrapper>
        {blockchain.errorMsg !== "" ? (
            <s.TextDescription>{blockchain.errorMsg}</s.TextDescription>
        ) : null}
        <s.Canvas hidden={select === 'video'}></s.Canvas>
        { select === 'video' ? (
            <s.VideoWrapepr>
              <LazyLoadComponent>
                <s.Video autoPlay loop muted playsInline hidden={activeNFT !== 0}>
                  <source src={video0}/>
                </s.Video>
              </LazyLoadComponent>
              <LazyLoadComponent>
                <s.Video autoPlay loop muted playsInline hidden={activeNFT !== 1}>
                  <source src={video1}/>
                </s.Video>
              </LazyLoadComponent>
              <LazyLoadComponent>
                <s.Video autoPlay loop muted playsInline hidden={activeNFT !== 2}>
                  <source src={video2}/>
                </s.Video>
              </LazyLoadComponent>
              <LazyLoadComponent>
                <s.Video autoPlay loop muted playsInline hidden={activeNFT !== 3}>
                  <source src={video3}/>
                </s.Video>
              </LazyLoadComponent>
              <LazyLoadComponent>
                <s.Video autoPlay loop muted playsInline hidden={activeNFT !== 4}>
                  <source src={videoGlassBlack}/>
                </s.Video>
              </LazyLoadComponent>
              <LazyLoadComponent>
                <s.Video autoPlay loop muted playsInline hidden={activeNFT !== 5}>
                  <source src={videoGlassRed}/>
                </s.Video>
              </LazyLoadComponent>
              <LazyLoadComponent>
                <s.Video autoPlay loop muted playsInline hidden={activeNFT !== 6}>
                  <source src={videoGlassCream}/>
                </s.Video>
              </LazyLoadComponent>
              <LazyLoadComponent>
                <s.Video autoPlay loop muted playsInline hidden={activeNFT !== 7}>
                  <source src={videoArt1}/>
                </s.Video>
              </LazyLoadComponent>
              <LazyLoadComponent>
                <s.Video autoPlay loop muted playsInline hidden={activeNFT !== 8}>
                  <source src={videoArt2}/>
                </s.Video>
              </LazyLoadComponent>
              <LazyLoadComponent>
                <s.Video autoPlay loop muted playsInline hidden={activeNFT !== 9}>
                  <source src={videoArt3}/>
                </s.Video>
              </LazyLoadComponent>
              <LazyLoadComponent>
                <s.Video autoPlay loop muted playsInline hidden={activeNFT !== 10}>
                  <source src={videoArt4}/>
                </s.Video>
              </LazyLoadComponent>
              <LazyLoadComponent>
                <s.Video autoPlay loop muted playsInline hidden={activeNFT !== 11}>
                  <source src={videoArt5}/>
                </s.Video>
              </LazyLoadComponent>
              <LazyLoadComponent>
                <s.Video autoPlay loop muted playsInline hidden={activeNFT !== 12}>
                  <source src={videoArt6}/>
                </s.Video>
              </LazyLoadComponent>
              <LazyLoadComponent>
                <s.Video autoPlay loop muted playsInline hidden={activeNFT !== 13}>
                  <source src={videoArt7}/>
                </s.Video>
              </LazyLoadComponent>
              <LazyLoadComponent>
                <s.Video autoPlay loop muted playsInline hidden={activeNFT !== 14}>
                  <source src={videoArt8}/>
                </s.Video>
              </LazyLoadComponent>
              <LazyLoadComponent>
                <s.Video autoPlay loop muted playsInline hidden={activeNFT !== 15}>
                  <source src={videoArt9}/>
                </s.Video>
              </LazyLoadComponent>
              <LazyLoadComponent>
                <s.Video autoPlay loop muted playsInline hidden={activeNFT !== 16}>
                  <source src={videoArt10}/>
                </s.Video>
              </LazyLoadComponent>
              <LazyLoadComponent>
                <s.Video autoPlay loop muted playsInline hidden={activeNFT !== 17}>
                  <source src={videoArt11}/>
                </s.Video>
              </LazyLoadComponent>
              <LazyLoadComponent>
                <s.Video autoPlay loop muted playsInline hidden={activeNFT !== 18}>
                  <source src={videoArt12}/>
                </s.Video>
              </LazyLoadComponent>
              <LazyLoadComponent>
                <s.Video autoPlay loop muted playsInline hidden={activeNFT !== 19}>
                  <source src={videoArt13}/>
                </s.Video>
              </LazyLoadComponent>
              <LazyLoadComponent>
                <s.Video autoPlay loop muted playsInline hidden={activeNFT !== 20}>
                  <source src={videoArt14}/>
                </s.Video>
              </LazyLoadComponent>
              <LazyLoadComponent>
                <s.Video autoPlay loop muted playsInline hidden={activeNFT !== 21}>
                  <source src={videoArt15}/>
                </s.Video>
              </LazyLoadComponent>
              <LazyLoadComponent>
                <s.Video autoPlay loop muted playsInline hidden={activeNFT !== 22}>
                  <source src={videoArt16}/>
                </s.Video>
              </LazyLoadComponent>
              <LazyLoadComponent>
                <s.Video autoPlay loop muted playsInline hidden={activeNFT !== 23}>
                  <source src={videoArt17}/>
                </s.Video>
              </LazyLoadComponent>
              <LazyLoadComponent>
                <s.Video autoPlay loop muted playsInline hidden={activeNFT !== 24}>
                  <source src={videoArt18}/>
                </s.Video>
              </LazyLoadComponent>
              <LazyLoadComponent>
                <s.Video autoPlay loop muted playsInline hidden={activeNFT !== 25}>
                  <source src={videoArt19}/>
                </s.Video>
              </LazyLoadComponent>
            </s.VideoWrapepr>
        ) : null}
      </s.Container>
    </s.Screen>
  );
}

export default App;